import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Returns the count of interview sessions with status = 'invited' (pending/incomplete)
 * for the current org.
 */
export function useActiveInterviewSessions() {
  const { profile } = useAuth();
  const orgId = profile?.org_id;

  return useQuery({
    queryKey: ['active-interview-sessions', orgId],
    queryFn: async () => {
      const { count, error } = await supabase
        .from('interview_sessions')
        .select('id, applications!inner(job_id, jobs!inner(org_id))', { count: 'exact', head: true })
        .eq('status', 'invited')
        .eq('applications.jobs.org_id', orgId!);

      if (error) {
        console.warn('[useActiveInterviewSessions]', error.message);
        return 0;
      }
      return count ?? 0;
    },
    enabled: !!orgId,
    staleTime: 2 * 60 * 1000,
  });
}
